import { Box } from '@/components/box/box';
import { FilterItem } from '@/components/filter/filter-item';
import { FilterWrapper } from '@/components/filter/filter-wrapper';
import { WorkSection } from '@/lib/schemas/work-section';
import NextLink from 'next/link';

interface Props {
  selectedSection: WorkSection;
  sections: Array<WorkSection>;
}

export function WorkNavigation({ selectedSection, sections }: Props) {
  if (!(selectedSection && sections)) {
    return null;
  }

  return (
    <Box
      css={{
        marginBottom: '$10',
        '@bp4': {
          marginBottom: 'unset',
        },
      }}
    >
      <FilterWrapper
        css={{
          '--item-width': '8em',
        }}
      >
        {sections.map((section) => (
          <NextLink
            key={section.category._id}
            href={`/work/${section.category.name.toLowerCase()}`}
            shallow
            passHref
          >
            <FilterItem
              key={section.category._id}
              label={section.category.name}
              selected={section.category.name === selectedSection.title}
              as="a"
            />
          </NextLink>
        ))}
      </FilterWrapper>
    </Box>
  );
}
